<template>
  <!-- 押金抵扣记录 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="communityGroupSearch">
        <el-select style="width: 100%" v-model="searchForm.communityGroup">
          <el-option
            v-for="item in communityGroupList"
            :key="item"
            :value="item.dictKey"
            :label="item.dictValue"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="communityIdSearch">
        <avue-input-tree
          node-key="id"
          v-model="searchForm.communityId"
          :props="{
            children: 'children',
            label: 'title',
          }"
          :dic="communityList"
          default-expand-all
          placeholder="请选择小区"
        >
        </avue-input-tree>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 100%"
        >
        </el-date-picker>
      </template>

      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.attachBtn"
          type="text"
          size="small"
          @click="openDialog('attach', row)"
        >
          凭证
        </el-button>
      </template>
      <!-- <template slot="communityGroup" slot-scope="{ row }">
        <span>{{ row.communityGroupName }}</span>
      </template> -->
      <template slot="communityId" slot-scope="{ row }">
        <span>{{ row.communityName }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      v-if="isDialogShow"
      width="60%"
      :title="dialogTitle"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <AttachManagement
        :fileList="currRowAttachList"
        :fileMaxNum="5"
        :fileMaxSize="12 * 1024 * 1024"
        fileType=".png,.jpg,.jpeg,.xlx,.xlsx,.doc,.docx,.ppt,.pptx"
        tips="（最多上传5个，单个文件限制在12Mb内，支持png、jpg、jpeg、xlx、xlsx、doc、docx、ppt、pptx类型文件）"
        :needDownload="true"
        @save="saveAttach"
        @close="closeDialog"
      ></AttachManagement>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import LazyTree from '@/views/components/lazy-tree';
import AttachManagement from './attach-management';
import { loadRoomTree1, getCommunityGroupList } from '@/api/charge/charge-pay';
import {
  getDepositDeductionPageList,
  getDepositDeductionAttachList,
  saveDepositDeductionAttachList,
} from '@/api/charge/deposit';

export default {
  name: 'DepositDeductionRecord',
  components: {
    LazyTree,
    AttachManagement,
  },
  data() {
    return {
      isParamReady: false, // 参数是否初始化完毕
      oldCommunityGroup: '', // 旧小区分组，重置搜索条件和新增时需要使用
      communityGroupList: [], // 小区分组
      communityList: [], // 小区列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      rowData: [], // 选中行对应的数据
      currRowAttachList: [], // 选中行的附件列表
      // 搜索条件
      searchForm: {
        communityGroup: '',
      },
      dateRange: [], // 搜索条件-起止日期
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 80,
        menuWidth: 80,
        column: [
          {
            label: '小区分组',
            prop: 'communityGroup',
            // slot: true,
            hide: true,
            showColumn: false,
            display: true,
            search: true,
            searchslot: true,
          },
          {
            label: '小区名称',
            prop: 'communityId',
            slot: true,
            search: true,
            searchslot: true,
          },
          {
            label: '房间信息',
            prop: 'propertyName',
          },
          {
            label: '缴费人',
            prop: 'payManName',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '抵扣时间',
            prop: 'deductTime',
          },
          {
            label: '收费日期',
            prop: 'dateRange',
            hide: true,
            showColumn: false,
            display: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '账单开始期',
            prop: 'billCycleNoStart',
          },
          {
            label: '账单截止期',
            prop: 'billCycleNoEnd',
          },
          {
            label: '押金类型',
            prop: 'defItemset',
          },
          {
            label: '抵扣金额',
            prop: 'deductAmount',
            align: 'right',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        attachBtn: this.vaildData(this.permission.depositDeductionRecord_attach, false),
      };
    },
  },
  watch: {
    'searchForm.communityGroup': {
      handler(val) {
        this.communityList = [];
        this.searchForm.communityId = '';
        if (val) {
          loadRoomTree1({
            communityGroup: this.searchForm.communityGroup,
          })
            .then(({ data }) => {
              this.communityList = data;
              this.searchForm.communityId = data[0].id;
              this.checkFirstLoadData();
            })
            .catch(() => {
              this.checkFirstLoadData();
            });
        }
      },
      immediate: true,
    },
  },
  created() {
    getCommunityGroupList().then(({ data }) => {
      this.communityGroupList = data;
      this.searchForm.communityGroup = data[0].dictKey;
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 首次加载数据 */
    checkFirstLoadData() {
      if (!this.isParamReady) {
        this.isParamReady = true;
        this.loadData();
      }
    },
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 390; // 表格区域初始化高度
      const searchH = 112; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.isParamReady) return;
      this.oldCommunityGroup = this.searchForm.communityGroup;
      page = page || this.tablePage;
      this.loading = true;
      getDepositDeductionPageList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {
        communityGroup: this.oldCommunityGroup,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.deductTimeSearchStart = this.dayjs(this.dateRange[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.searchForm.deductTimeSearchEnd = this.dayjs(this.dateRange[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
      } else {
        this.searchForm.deductTimeSearchStart = '';
        this.searchForm.deductTimeSearchEnd = '';
        this.dateRange = [];
      }
    },
    /* 打开弹框 */
    async openDialog(type, rowData = {}) {
      let titles = {
        attach: '凭证',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'attach') {
        const res = await getDepositDeductionAttachList({
          deductId: this.rowData.id,
        });
        // fixme 处理返回值
        this.currRowAttachList = res.data;
      }
      this.needCloseConfirm = true;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 保存附件 */
    saveAttach(attachList) {
      saveDepositDeductionAttachList(
        {
          deductId: this.rowData.id,
          attachList,
        },
        {
          showLoading: { text: '处理中...' },
        }
      ).then(() => {
        this.$message.success('操作成功!');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
